import React from "react";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import { Link, useLocation } from "react-router-dom";
import { Grid } from "@material-ui/core";
import { Text } from "~/components/elements";
import PropTypes from "prop-types";

import * as S from "./styles";

export default function Breadcrumb({ navBreadcrumb }) {
  const location = useLocation();
  return (
    <S.BreadcrumbHolder>
      <Grid container justifyContent="space-between">
        <Breadcrumbs separator="›" aria-label="breadcrumb">
          {navBreadcrumb?.map(({ text, link }, index) => {
            return (
              <Link to={link + location.search} key={index}>
                {index === navBreadcrumb.length - 1 ? (
                  <Text as="strong" level="2" className="text">
                    {text}
                  </Text>
                ) : (
                  <Text level="2" className="text">{text}</Text>
                )}
              </Link>
            );
          })}
        </Breadcrumbs>
      </Grid>
    </S.BreadcrumbHolder>
  );
}
Breadcrumb.defaultProps = {
  navBreadcrumb: [],
};

Breadcrumb.propTypes = {
  navBreadcrumb: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      link: PropTypes.string,
    })
  ),
};
